import { Injectable } from '@angular/core';
import { Global } from './classes/Global';
import { ICountryChangedListener } from './classes/ICountryChangedListener';

@Injectable()
export class CountryService {

  country: string;
  countryChangedListeners: ICountryChangedListener[] = [];

  isEU: boolean;

  constructor() {
    this.country = Global.getCountry();
  }

  setCountry(country:string) {
    this.country = country;
    for(let listener of this.countryChangedListeners) {
      listener.onCountryChanged(this.country);
    }
  }

  getCountry(): string {
    return this.country;
  }

  addEventListener(listener: ICountryChangedListener) {
    this.countryChangedListeners.push(listener);
  }

}
